import { render, staticRenderFns } from "./DedicationForm.vue?vue&type=template&id=6ec8898c"
import script from "./DedicationForm.vue?vue&type=script&lang=js"
export * from "./DedicationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports